<template>
	<div id="app">
		<b-modal v-model="isIdle" @hidden="idleLogout">Your session has expired due to inactivity</b-modal>
		<nav id="nav" class="nav fixed-top navbar navbar-expand-md navbar-light bg-light">
			<a class="navbar-brand logo-wrapper"><img src="./danox-logo.svg" class="logo"/></a>
			<!--<h3 class="abs">DANOX 3DS</h3>-->
			<div class="mr-2 w-100 text-right">
				<div class="col-12">
					<strong>Welcome to <span style="color: rgb(119, 119 122)">Danox </span> <span
							style="color: rgb(131, 186, 35)">3DS</span></strong>
				</div>
				<div class="col-12">
					<b-dropdown v-if="showSidebar" class="ml-auto" :text="username" size="sm" right>
						<b-dropdown-item @click="logout" size="sm">Logout</b-dropdown-item>
					</b-dropdown>
				</div>
			</div>
			<!--<h2 style="padding-top: 10px;" class="mx-auto">Danox 3DS</h2>-->
		</nav>
		<div id="wrapper" :class="{toggled : showSidebar}" style="position: sticky;">
			<!-- Sidebar -->
			<div id="sidebar-wrapper">
				<ul class="sidebar-nav">
					<!--<li class="sidebar-brand">
                      <a href="#">
                        Start Bootstrap
                      </a>
                    </li>-->
					<li>
						<router-link
								:class="{'sidebar-active' : $route.name === 'companies' || $route.name === 'company'}"
								to="/companies">
							Companies
						</router-link>
					</li>
					<li>
						<router-link
								:class="{'sidebar-active' : $route.name === 'registrations' || $route.name === 'registration'}"
								to="/registrations">Registrations
						</router-link>
					</li>
					<li>
						<router-link
								:class="{'sidebar-active' : $route.name === 'jobs' || $route.name === 'job-view' || $route.name === 'job-edit'}"
								to="/jobs">Jobs
						</router-link>
					</li>
					<li>
						<router-link
								:class="{'sidebar-active' : $route.name === 'containers' || $route.name === 'container-view' || $route.name === 'container-edit'}"
								to="/containers">Containers
						</router-link>
					</li>
					<li>
						<router-link
								:class="{'sidebar-active' : $route.name === 'line-items' || $route.name === 'line-item-view' || $route.name === 'line-item-edit'}"
								to="/line-items">Line Items
						</router-link>
					</li>
					<li>
						<router-link
								:class="{'sidebar-active' : $route.name === 'yb-containers' || $route.name === 'yb-container-view' || $route.name === 'yb-container-edit'}"
								to="/yb-containers">Yellow Bucket
						</router-link>
					</li>
					<li>
						<router-link
								:class="{'sidebar-active' : $route.name === 'yb-line-items' || $route.name === 'yb-line-item-view' || $route.name === 'yb-line-item-edit'}"
								to="/yb-line-items">Yellow Bucket Line Items
						</router-link>
					</li>
					<li>
						<router-link
								:class="{'sidebar-active' : $route.name === 'dictionaries' || $route.name === 'dictionary'}"
								to="/dictionaries">Dictionary
						</router-link>
					</li>
          <li>
            <router-link
                :class="{'sidebar-active' : $route.name === 'reports' || $route.name === 'reports'}"
                to="/reports">Reports
            </router-link>
          </li>
					<!--<li>
                      <a href="#">Services</a>
                    </li>
                    <li>
                      <a href="#">Contact</a>
                    </li>-->
				</ul>
				<div
						style="width: 20px; background-color: rgb(131, 186, 35); position: absolute; height: 100%; left:230px;"></div>
			</div>
			<!-- /#sidebar-wrapper -->
			<!--<div class="sidebar-toggler-expanded">
              <a v-if="showSidebar" @click.prevent="showSidebar = false"><font-awesome-icon class="sidebar-toggler-icon-expanded" icon="chevron-circle-left"></font-awesome-icon></a>
              <a v-else @click.prevent="showSidebar = true"><font-awesome-icon class="sidebar-toggler-icon-expanded" icon="chevron-circle-right"></font-awesome-icon></a>
            </div>-->
			<div id="page-content-wrapper">
				<div v-show="overlay" id="overlay"></div>
				<div class="container-fluid">
					<router-view
							:key="$route.path"
							v-on:toggle-edit-mode="test"
							v-on:set-show-sidebar="showSidebar = $event.showSidebar"
					></router-view>
				</div>
			</div>
		</div>
		<!--<nav v-if="editMode" id="nav-bottom" :class="{ 'edit-mode': editMode }" class="nav fixed-bottom navbar navbar-expand-md navbar-light bg-light">
          <div class="text-right" style="width: 50%; margin-right:1em;">
            <button class="btn btn-secondary" style="width:75px;">Cancel</button>
          </div>
          <div class="text-left" style="width: 50%; margin-left:1em;">
            <button class="btn btn-primary" style="width:75px;">Save</button>
          </div>
        </nav>-->
	</div>
</template>
<script>
import {mapActions} from 'vuex'
import feedbackMixin from '@/mixins/feedback'

export default {
	name: 'App',
	mixins: [feedbackMixin],
	data() {
		return {
			editMode: false,
			showSidebar: true
		}
	},
	methods: {
		...mapActions({
			_logout: 'logout'
		}),
		test: function () {
			alert('WTF!')
		},
		logout: function () {
			console.log('Logging out');
			let that = this;
			this.axios.post('/3ds/api/logout')
				.then(value => {
					this.pushError({
						message: 'You have successfully logged out',
						type: 'SUCCESS'
					});
					/*this._logout()
						.then(() => {
							that.$router.push('/')
						})*/
				})
				.catch(reason => {
					console.log('An error occurred on logout')
					console.log(JSON.stringify(reason))

					this.pushError({
						message: 'You have successfully logged out',
						type: 'SUCCESS'
					});
					/*this._logout()
						.then(() => {
							that.$router.push('/')
						})*/
				})
				.finally(() => {
					localStorage.removeItem('token')
					this.$router.push('/')
				})
		},
		idleLogout: function () {
			if(this.$route.name !== 'login') {
				this.logout()
			}
		}
	},
	computed: {
		isIdle() {
			return this.$route.name !== 'login' && this.$store.state.idleVue.isIdle;
		}
	}
}
</script>
<style>
.modal-title {
    color: rgb(131, 186, 35) !important;
}
.modal-title > h5 {
    margin-bottom: 0 !important;
}

::v-deep .select2-close-mask{
    z-index: 2099 !important;
}

::v-deep .select2-dropdown{
    z-index: 3051 !important;
}

.form-control {
	height: 34px !important;;
}

.table-responsive {
    overflow-scrolling: auto !important;
}

.abs {
    position: absolute;
    width: 100%;
    left: 0;
    text-align: center;
}

.logo-wrapper {
    width: 250px;
}

img.logo {
    width: 200px;
}

.sidebar-toggler-icon-expanded {
    position: fixed;
    top: 50%;
    /*margin-top: -25px;*/
    z-index: 1000;
}

.sidebar-toggler-icon-collapsed {
    position: fixed;
    top: 50%;
    /*margin-top: -25px;*/
    left: 0;
    z-index: 1000;
}

#nav {
    background-color: #ffffff;
}

#nav-bottom {
    background-color: #ffffff;
}

#nav {
    border-bottom: thin solid lightgray;
    background-color: rgb(247, 247, 247) !important;
}

#nav-bottom {
    border-top: thin solid lightgray;
}

body {
    overflow-x: hidden;
}

#wrapper {
    padding-left: 0;
    -webkit-transition: all 0.5s ease;
    -moz-transition: all 0.5s ease;
    -o-transition: all 0.5s ease;
    transition: all 0.5s ease;
}

#wrapper.toggled {
    padding-left: 250px;
}

#sidebar-wrapper {
    z-index: 1000;
    position: fixed;
    left: 250px;
    width: 0;
    height: 100%;
    margin-left: -250px;
    overflow-y: auto;
    background: #000;
    -webkit-transition: all 0.5s ease;
    -moz-transition: all 0.5s ease;
    -o-transition: all 0.5s ease;
    transition: all 0.5s ease;
}

#wrapper.toggled .sidebar-toggler-icon-expanded {
    left: 251px;
}

#wrapper.toggled .sidebar-toggler-expanded {
    left: 250px;
}

#wrapper.toggled #sidebar-wrapper {
    width: 250px;
}

#page-content-wrapper {
    width: 100%;
    position: absolute;
    padding: 15px;
}

#wrapper.toggled #page-content-wrapper {
    position: absolute;
    margin-right: -250px;
}

/* Sidebar Styles */

.sidebar-nav {
    position: absolute;
    /*top: 4em;*/
    width: 250px;
    margin: 0;
    padding: 20px 0 0 0;
    list-style: none;
}

.sidebar-toggler-expanded {
    position: absolute;
    width: 19px;
    background-color: rgb(131, 186, 35);
    height: 100%;
}

.sidebar-toggler-collapsed {
    position: absolute;
    left: 0;
    width: 19px;
    background-color: rgb(131, 186, 35);
    height: 100%;
}

.sidebar-nav li {
    text-indent: 20px;
    line-height: 40px;
}

.sidebar-nav li a {
    display: block;
    text-decoration: none;
    color: #999999;
}

.sidebar-nav li a:hover {
    text-decoration: none;
    color: #fff;
    background: rgba(255, 255, 255, 0.2);
}

.sidebar-nav li a:active, .sidebar-nav li a:focus {
    text-decoration: none;
}

.sidebar-nav > .sidebar-brand {
    height: 65px;
    font-size: 18px;
    line-height: 60px;
}

.sidebar-nav > .sidebar-brand a {
    color: #999999;
}

.sidebar-nav > .sidebar-brand a:hover {
    color: #fff;
    background: none;
}

.dropdown-item {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}

.dropdown-item:hover {
    color: #007bff !important;
}

@media (min-width: 768px) {
    #wrapper {
        padding-left: 0;
    }

    #wrapper.toggled {
        padding-left: 250px;
    }

    #sidebar-wrapper {
        width: 0;
    }

    #wrapper.toggled #sidebar-wrapper {
        width: 250px;
    }

    #page-content-wrapper {
        /*top: 4em;*/
        margin-top: 4em;
        padding: 20px;
        position: relative;
    }

    /*.edit-mode {
      margin-bottom: 2em;
    }*/
    #wrapper.toggled #page-content-wrapper {
        position: relative;
        margin-right: 0;
    }

    .sidebar-active {
        color: yellow !important;
    }

    .container-fluid > .card > .card-body {
        margin-bottom: 0;
        padding-bottom: 0;
    }

    .dropdown-item:hover, .dropdown-item:focus {
        background-color: transparent !important;
    }

    #overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 10;
        background-color: rgba(0, 0, 0, 0.5); /*dim the background*/
    }

    .spotlight {
        z-index: 11;
    }
}
</style>
